import { array } from '@ember/helper';
import { on } from '@ember/modifier';

import joinClasses from 'webapp/helpers/join-classes';
import visibleCheckItem from 'webapp/modifiers/visible-check-item';
import BlockDebugButtonComponent from 'webapp/components/block/debug-button';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import DummyCellComponent from 'webapp/components/dummy-cell';
import EditableModelPropertyComponent from 'webapp/components/editable-model-property';
import FormCheckboxComponent from 'webapp/components/form/checkbox';
import type { Args } from 'webapp/components/goals/item-base';
import GoalsItemBaseComponent from 'webapp/components/goals/item-base';
import GoalsProgressComponent from 'webapp/components/goals/progress';
import GoalsStatusComponent from 'webapp/components/goals/status/index';
import GroupSelectComponent from 'webapp/components/group-select';
import OptionsButtonComponent from 'webapp/components/options-button';
import OwnerSelectComponent from 'webapp/components/owner-select';

export default abstract class GoalsTableRowComponent extends GoalsItemBaseComponent<Args> {
	<template>
		{{#if this.isVisibleOnScreen}}

			<tr
				data-id={{@model.id}}
				class={{joinClasses
					(array
						"table-row"
						"goal-item"
						this.goalData.currentProgressClass
						(if @hideSort "hideSort")
						(if this.isSelected "selected")
					)
				}}
			>
				<td class="cc no-grow">
					{{#if this.showDragHandle}}
						<div class="drag" data-id={{@model.id}}>
							<CommonUiIconComponent @name="ArrowsMove" @size="md" />
						</div>
					{{/if}}
					{{#if @batchSelect}}
						<FormCheckboxComponent
							@name="goals-table-row"
							@selected={{this.isSelected}}
							@theme="blue"
							@onChange={{this.selectItem}}
						/>
					{{/if}}
				</td>

				<td class="c0 no-grow first">

					<span class="target" role="button" {{on "click" this.viewDetails}}>
						<CommonUiIconComponent @name="Target" @size="xl" />
						{{#if this.emblemTypeName}}
							<div class="emblem emblem--{{this.emblemTypeName}}"></div>
						{{/if}}
					</span>

					<BlockDebugButtonComponent @blockId={{@model.blockId}} />
				</td>

				<td class="c1">
					<div class="flex">
						<EditableModelPropertyComponent
							@model={{@model}}
							@canEdit={{@model.canEdit}}
							@trackingObj={{this.goalRenamedTrackingObj}}
						/>
						<div class="labelicons">
							{{#if @model.favorite}}
								<span class="labelicon">
									<CommonUiIconComponent @name="StarFill" @size="sm" />
								</span>
							{{/if}}
						</div>
					</div>

					{{#if @model.group}}
						<GroupSelectComponent @model={{@model}} @canEdit={{false}} />
					{{/if}}
				</td>

				<td class="c2 no-grow" data-label="Progress: ">
					<GoalsProgressComponent
						@model={{@model}}
						@goalData={{this.goalData}}
						@size="small"
					/>
				</td>

				<td class="c3" data-label="Timeframe: ">
					{{@model.timeframeText}}
				</td>

				<td class="c4 prio-low" data-label="Status: ">
					{{#if this.goalData.status}}
						<GoalsStatusComponent @status={{this.goalData.status}} />
					{{/if}}
				</td>

				<td class="c5 prio-low" data-label="Owner: ">
					<OwnerSelectComponent
						@model={{@model}}
						@canEdit={{@model.canEdit}}
						@isOwnerNameHidden={{true}}
					/>
				</td>

				<td class="c6 button-ct last">
					<OptionsButtonComponent
						@options={{this.options}}
						@onAction={{this.doOptionsAction}}
					/>
				</td>
			</tr>

		{{else}}

			<tr
				data-id={{@model.id}}
				class="table-row board"
				{{visibleCheckItem this.visibleChanged this.checkVisibility}}
			>
				<DummyCellComponent />
			</tr>

		{{/if}}
	</template>
}
